/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import StringResources from 'nls/StringResources';
import {
	Select,
	Label
} from '@ba/ba-ui-carbon-toolkit';

export default class ColorMode extends PureComponent {

	static propTypes = {
		selectedColorType: PropTypes.string,
		onChange: PropTypes.func
	}
	static defaultProps = {
		selectedColorType: 'RGB'
	};

	render() {
		const myList = [
			{ value: 'RGB', label: StringResources.get('modelRGB') },
			// { value: 'CMYK', label: StringResources.get('modelCMYK') },
			{ value: 'HSB', label: StringResources.get('modelHSB') }
		];
		return (
			<div>
				<Label id="idSelectColorModeLabel" label={StringResources.get('colorModel')}/>
				<div>
					<Select
						light
						selected={this.props.selectedColorType}
						options={myList}
						onChange={this.props.onChange}
						aria-labelledby="idSelectColorModeLabel"
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/ColorMode.js